import request from '@/utils/request'

// 上传课程资料
export function uploadCourseResource(courseId, file, description) {
  const formData = new FormData()
  formData.append('courseId', courseId)
  formData.append('file', file)
  if (description) {
    formData.append('description', description)
  }

  return request({
    url: '/course-resource/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取课程资料列表
export function getCourseResourceList(courseId) {
  return request({
    url: `/course-resource/list/${courseId}`,
    method: 'get'
  })
}

// 删除课程资料
export function deleteCourseResource(resourceId) {
  return request({
    url: `/course-resource/delete/${resourceId}`,
    method: 'delete'
  })
}

// 修改课程资料
export function updateCourseResource(resourceId, description, file) {
  const formData = new FormData()
  if (description) {
    formData.append('description', description)
  }
  if (file) {
    formData.append('file', file)
  }

  return request({
    url: `/course-resource/update/${resourceId}`,
    method: 'put',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 下载课程资料
export function downloadCourseResource(resourceId) {
  return request({
    url: `/course-resource/download/${resourceId}`,
    method: 'get',
    responseType: 'blob'
  })
}
